import { Flex, ProductColor, theme } from '@aloft/toolkit-sui';

import { selectAivArvActiveTab } from '../../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { PROPERTY_HEADER_COLOR_BAND_HEIGHT, PROPERTY_HEADER_IMAGE_HEIGHT } from '../consts.ts';

type LabelColumnHeaderSectionProps = {
  content: React.ReactNode;
};

export const LabelColumnHeaderSection = ({ content }: LabelColumnHeaderSectionProps) => {
  const activeTab = useAppSelector(selectAivArvActiveTab);

  let backgroundColor: ProductColor = 'surface6';
  if (activeTab === 'aiv') backgroundColor = 'aivLight';
  else if (activeTab === 'arv') backgroundColor = 'arvLight';

  return (
    <Flex
      position="sticky"
      top="0"
      zIndex={theme.zIndices.sticky}
      backgroundColor={backgroundColor}
      width="100%"
      height={`calc(${PROPERTY_HEADER_IMAGE_HEIGHT} + ${PROPERTY_HEADER_COLOR_BAND_HEIGHT} + 1px)`}
      __dangerDoNotUseSx={{ borderBottom: `1px solid ${theme.colors.strokeDefault}` }}
    >
      {content}
    </Flex>
  );
};
